// removed by extract-text-webpack-plugin
module.exports = {"title":"ColumnWidths__title___3011V","linked":"ColumnWidths__linked___2uppC","communication":"ColumnWidths__communication___2yGhr","date":"ColumnWidths__date___2_BK7","pie":"ColumnWidths__pie____hSxm","users":"ColumnWidths__users___3KfHc","actions":"ColumnWidths__actions___2k_LZ","note":"ColumnWidths__note___1raSA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityTableDetail/ColumnWidths.scss
// module id = 515
// module chunks = 1